import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { api as platformApi } from './platformApi';
import auth from './slices/auth';
import config from './slices/config';
import room from './slices/room';
import streamingViewHistory from './slices/streamingViewHistory';
import { api as streamGoApi } from './streamGoApi';

const LIVEKIT_ROOM_IN_STATE = 'room.room';

export const rootReducer = combineReducers({
  [streamGoApi.reducerPath]: streamGoApi.reducer,
  [platformApi.reducerPath]: platformApi.reducer,
  config,
  auth,
  room,
  streamingViewHistory,
});

export type RootState = ReturnType<typeof rootReducer>;

export const makeStore = (preloadedState?: Partial<RootState>) =>
  configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        immutableCheck: { ignoredPaths: [LIVEKIT_ROOM_IN_STATE] },
      })
        .concat(streamGoApi.middleware)
        .concat(platformApi.middleware),
  });

export const store = makeStore();

export type AppStore = ReturnType<typeof makeStore>;
export type AppDispatch = AppStore['dispatch'];
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
